import { useEffect, useState } from "react";

function AdmissionDetails() {
  const [admissionData, setAdmissionData] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  const url = process.env.REACT_APP_API_URL;
  const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;

  const fetchData = async () => {
    try {
      const response = await fetch(`${url}/admission-pay/details/${userData?.user_id}`);
      const res = await response.json();

      // ✅ Sort newest first by createdAt
      const sorted = (res.data || []).sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      setAdmissionData(sorted);
    } catch (error) {
      console.log(error);
    }
  };


  const fetchAllData = async () => {
    try {
      const response = await fetch(`${url}/`)
    } catch (error) {
      console.log(error)
    }
  }


  const formatDateTime = (dateStr) => {
    const date = new Date(dateStr);
    return isNaN(date)
      ? "—"
      : date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return isNaN(date)
      ? "—"
      : date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="admission-container">
      {admissionData.length === 0 ? (
        <div className="no-record">No admission records found.</div>
      ) : (
        admissionData.map((item, index) => (
          <div key={item.id} className="accordion-card">
            {/* Accordion Header */}
            <div
              className="accordion-header"
              onClick={() => toggleAccordion(index)}
            >
              <div className="header-left">
                <div className="student-name">{item.name}</div>
                <div className="payment-id">Transaction ID: {item.payment_id}</div>
                <div className="payment-id">
                  {formatDateTime(item.createdAt)}
                </div>
              </div>
              <div className="header-right">
                <span
                  className={`status ${item.status === "Paid" ? "paid" : "unpaid"
                    }`}
                >
                  {item.status === "Paid" ? "Paid" : "Failed"}
                </span>
                <span className="toggle-icon">
                  {openIndex === index ? "▲" : "▼"}
                </span>
              </div>
            </div>

            {/* Accordion Body */}
            {openIndex === index && (
              <div className="accordion-body">
                <div className="info-grid">
                  <div><strong>Father Name:</strong> {item.fatherName || "—"}</div>
                  <div><strong>Mother Name:</strong> {item.motherName || "—"}</div>
                  <div><strong>Email:</strong> {item.email}</div>
                  <div><strong>Mobile:</strong> {item.mobile}</div>
                  <div><strong>DOB:</strong> {formatDate(item.dob)}</div>
                  <div><strong>Gender:</strong> {item.gender || "—"}</div>
                  <div><strong>Center:</strong> {item.center}</div>
                  <div><strong>Address:</strong> {item.address}</div>
                  <div><strong>Pincode:</strong> {item.pincode}</div>
                  <div><strong>School:</strong> {item.school || "—"}</div>
                  <div><strong>Aadhar:</strong> {item.aadhar || "—"}</div>
                  <div><strong>Rules Agreed:</strong> {item.rulesAgreed === "1" ? "Yes" : "No"}</div>
                  {/* ✅ Courses list */}
                  <div>
                    <strong>Course:</strong>{" "}
                    {(() => {
                      try {
                        const products = JSON.parse(item.cart_products || "[]");
                        return products.length > 0 ? (
                          <>
                            {products.map((p, idx) => (
                              <span key={idx}>{p.product_name}</span>
                            ))}
                          </>
                        ) : (
                          "—"
                        );
                      } catch (err) {
                        return "—";
                      }
                    })()}
                  </div>

                  {/* ✅ Amount list */}
                  <div><strong>Amount:</strong> {item.amountafterdiscount || "—"}</div>

                </div>
                <div className="created-at">
                  Record Created: {formatDateTime(item.createdAt)}
                </div>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default AdmissionDetails;
